import * as React from "react";
import Component from "../../AbstractComponent";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { TableComponent } from "../Table/TableComponent";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import CircularProgress from '@material-ui/core/CircularProgress';
import Translator from "../../../Translation/Translator";

export default class Payments2List extends Component {
	protected searchTimer;

	public state = {
		directIndirectPayments: [],
		selectedDirectIndirectPaymentsRows: [],
		payerPayments: [],
		selectedPayerPaymentsRows: [],
		filteredPayments: [],
		selectedFilteredPaymentsRows: [],
		selectedPersonForExistingPayments: null,
		selectedCompanyForExistingPayments: null,
		existingPayerChoice: "person",
		showDirectIndirectPaymentsList: false,
		paymentSearchString: "", 
		paymentSearchInProgress: false
	};

  constructor(public props) {
    super(props);
	}

	public componentWillMount() {
		this.setState({
			directIndirectPayments: this.props.directIndirectPayments,
			selectedDirectIndirectPaymentsRows: this.props.selectedDirectIndirectPaymentsRows,
			payerPayments: this.props.payerPayments,
			selectedPayerPaymentsRows: this.props.selectedPayerPaymentsRows,
			filteredPayments: this.props.filteredPayments,
			selectedFilteredPayments: this.props.selectedFilteredPayments,
			selectedPersonForExistingPayments: this.props.selectedPersonForExistingPayments,
			selectedCompanyForExistingPayments: this.props.selectedCompanyForExistingPayments,
			existingPayerChoice: this.props.existingPayerChoice,
			showDirectIndirectPaymentsList: !!this.props.directIndirectPayments && this.props.directIndirectPayments.length > 0,
			paymentSearchInProgress: this.props.paymentSearchInProgress,
		});
	}

	public componentWillReceiveProps(nextProps) {
		if (JSON.stringify(this.state.directIndirectPayments) !== JSON.stringify(nextProps.directIndirectPayments)) {
			this.setState({
				showDirectIndirectPaymentsList: !!nextProps.directIndirectPayments &&
																			 nextProps.directIndirectPayments.length > 0
			});
		}

		this.setState({
			directIndirectPayments: nextProps.directIndirectPayments,
			selectedDirectIndirectPaymentsRows: nextProps.selectedDirectIndirectPaymentsRows,
			payerPayments: nextProps.payerPayments,
			selectedPayerPaymentsRows: nextProps.selectedPayerPaymentsRows,
			filteredPayments: nextProps.filteredPayments,
			selectedFilteredPayments: nextProps.selectedFilteredPayments,
			selectedPersonForExistingPayments: nextProps.selectedPersonForExistingPayments,
			selectedCompanyForExistingPayments: nextProps.selectedCompanyForExistingPayments,
			existingPayerChoice: nextProps.existingPayerChoice,
			paymentSearchInProgress: nextProps.paymentSearchInProgress,
		});
	}

	public getPayments = (payments: PaymentInterface[], selectedPaymentsRows: number[], callback: any): any => {
		if(typeof this.props.getPayments === "function") {
			return this.props.getPayments.call(this, payments, selectedPaymentsRows, callback);
		}
	}

	public onDirectIndirectPaymentRowSelection = (event, rows: number[]): void => {
		if(typeof this.props.onDirectIndirectPaymentRowSelection === "function") {
			return this.props.onDirectIndirectPaymentRowSelection.call(this, event, rows);
		}
	}

	public onPayerPaymentRowSelection = (event, rows: number[]): void => {
		if(typeof this.props.onPayerPaymentRowSelection === "function") {
			return this.props.onPayerPaymentRowSelection.call(this, event, rows);
		}
	}

	public onFilteredPaymentRowSelection = (event, rows: number[]): void => {
		if(typeof this.props.onFilteredPaymentRowSelection === "function") {
			return this.props.onFilteredPaymentRowSelection.call(this, event, rows);
		}
	}

	public selectPersonForExistingPayments = (person: PersonInterface): void => {
		if(typeof this.props.selectPersonForExistingPayments === "function") {
			return this.props.selectPersonForExistingPayments.call(this, person);
		}
	}

	public clearPersonForExistingPayments = (): void => {
		if(typeof this.props.clearPersonForExistingPayments === "function") {
			return this.props.clearPersonForExistingPayments();
		}
	}

	public selectCompanyForExistingPayments = (company: CompanyInterface): void => {
		if(typeof this.props.selectCompanyForExistingPayments === "function") {
			return this.props.selectCompanyForExistingPayments.call(this, company);
		}
	}

	public clearCompanyForExistingPayments = (): void => {
		if(typeof this.props.clearCompanyForExistingPayments === "function") {
			return this.props.clearCompanyForExistingPayments();
		}
	}

	public changeExistingPayerChoice = (event): void => {
		if(typeof this.props.changeExistingPayerChoice === "function") {
			return this.props.changeExistingPayerChoice.call(this, event, choice => {
				if (choice === "person") {
					return (this.refs.selectedPersonForExistingPaymentsLookup as any) && (this.refs.selectedPersonForExistingPaymentsLookup as any).refs.instance.ref.focus();
				}

				return (this.refs.selectedCompanyForExistingPaymentsLookup as any) && (this.refs.selectedCompanyForExistingPaymentsLookup as any).refs.instance.ref.focus();
			});
		}
	}

	public switchListView = (): void => {
		this.setState({
			showDirectIndirectPaymentsList: !this.state.showDirectIndirectPaymentsList
		})
	}

	public setSearchString = (event): any => {
    clearTimeout(this.searchTimer);

    this.setState({
      paymentSearchString: event.target.value
    }, () => {
      if (this.state.paymentSearchString === "") {
        this.clearSearchString();
      }

      this.searchTimer = setTimeout(() => {
        if (typeof this.props.updatePaymentSearchString === "function") {
					this.props.updatePaymentSearchString(this.state.paymentSearchString);
				}
      }, this.props.app?.listSearchTimeout);
    });
  }

	public clearSearchString = () => {
    this.setState({
      paymentSearchString: ""
    }, () => {
			if (typeof this.props.updatePaymentSearchString === "function") {
				this.props.updatePaymentSearchString(this.state.paymentSearchString);
			}
		});
  }

  public render() {
		const exsistingDirectIndirectPaymentsAmount: number =
			this.state.directIndirectPayments?.map((payment: PaymentInterface, index: number) => {
				if (this.state.selectedDirectIndirectPaymentsRows?.includes(index)) {
					const amountUnused = payment?.amountRemaining;

					return amountUnused;
				}

				return 0;
			}).reduce((a, b) => a + b, 0);

		const exsistingPayerPaymentsAmount: number =
			this.state.payerPayments && this.state.payerPayments.map((payment: PaymentInterface, index: number) => {
				if (this.state.selectedPayerPaymentsRows.includes(index)) {
					const amountUnused = payment?.amountRemaining;

					return amountUnused;
				}

				return 0;
			}).reduce((a, b) => a + b, 0);

    return (
			<Card 
				className="card" 
				style={{
					marginBottom: "20px"
				}}
			>
				<div style={{padding: "0 0 20px 10px"}}>
					{
						this.props.directIndirectPayments?.length === 0 && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.props.modalDescription || this.trans("page/chargeupdate-hint/chargehasnotmatchingpayments")}</div>
					}

					{
						this.props.directIndirectPayments?.length > 0 && 
						<div style={{padding: "10px 24px 5px 0"}}>{this.trans("page/chargeupdate-hint/chargehasmatchingpayments")}</div>
					}
					<div>
						<div>
							{
								this.state.directIndirectPayments && this.state.directIndirectPayments.length > 0 &&
									<div
										// style={{position: "absolute", right: "20px"}}
									>
										<FormControlLabel
											control={
												<Switch
													checked={this.state.showDirectIndirectPaymentsList}
													onChange={this.switchListView}
													color="primary"
												/>
												}
											label={this.trans("section/payment-tab/existing-switch/listswitcher-label")}
										/>
									</div>
							}

							{
								this.state.showDirectIndirectPaymentsList && (
									<div style={{marginTop: "20px"}}>
										{
											!this.props.hideTotalAmount && this.state.directIndirectPayments && this.state.directIndirectPayments.length > 0 && (
												<div
													style={{
														padding: "0 24px 15px 0",
														fontSize: "14px",
														display: "flex",
														justifyContent: "flex-end",
														textAlign: "center"
													}}
												>
													{Translator.transJSX("total-amount", {
														amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(exsistingDirectIndirectPaymentsAmount, this.props.app.settings.user.currency)}</span>
													})}
												</div>
											)
										}

										<TableComponent
											{...this.props}
											paginator={{
												name: "ExistingDirectIndirectPaymentsList",
												path: this.props.app.paginator
											}}
											className="listing-table existing-payments-table"
											rows={this.getPayments(this.state.directIndirectPayments,
																						this.state.selectedDirectIndirectPaymentsRows,
																						this.onDirectIndirectPaymentRowSelection)
											}
										/>
									</div>
								)
							}

							{
								!this.state.showDirectIndirectPaymentsList && (
									<div style={{padding: "10px 0 0 0"}}>
										<div className="list-filterer">
											<TextField
												className="form-element full-size"
												autoComplete="off"
												type="text"
												style={{color: "rgb(0, 188, 212)"}}
												label={this.trans("label/searchpayment")}
												value={this.state.paymentSearchString}
												onChange={this.setSearchString}
												variant="standard"
												error={false}
											/>
											{ 
												this.state.paymentSearchString !== "" &&
												<div className="icon icon-ic-close clear-button clear-button-search" onClick={this.clearSearchString}></div>
											}
											{ 
												this.state.paymentSearchInProgress &&
												<div className="search-loader">
													<CircularProgress size={20} />
												</div>
											}
										</div>
										<div style={{marginTop: "20px"}}>
											{
												!this.props.hideTotalAmount && this.state.payerPayments && this.state.payerPayments.length > 0 && (
													<div
														style={{
															padding: "0 24px 15px 0",
															fontSize: "14px",
															display: "flex",
															justifyContent: "flex-end",
															textAlign: "center"
														}}
													>
														{Translator.transJSX("total-amount", {
															amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(exsistingPayerPaymentsAmount, this.props.app.settings.user.currency)}</span>
														})}
													</div>
												)
											}

											<TableComponent
												{...this.props}
												paginator={{
													name: "ExistingPayerPaymentsList",
													path: this.props.app.paginator
												}}
												className="listing-table existing-payments-table"
												rows={this.getPayments(this.state.payerPayments, this.state.selectedPayerPaymentsRows, this.onPayerPaymentRowSelection)}
											/>
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>
			</Card>
    );
  }
}
